import React, { useEffect, useState } from 'react';
import * as ReactBootStrap from "react-bootstrap";
import "./Esign.css"

function EsigneDownload() {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [Esignname, setName] = useState(null);
  const [postal, setPostal] = useState(null)
  const [pseudonym, setPseudonym] = useState(null);

  useEffect(() => {
    // Get the TxnId from the query parameters
    const urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams)
    const txnId = urlParams.get('txn_no');
    console.log(txnId)

    if (txnId) {
      const payload = {
        data: {
          txn_no: txnId
        }
      };

      // Make a request to the first API with the TxnId as the payload
      fetch('https://dnf65oncc2.execute-api.ap-south-1.amazonaws.com/default/lmbd_ainxt_emudhra_demo_security_request', {
        method: 'POST',
        headers: {
          'x-api-key': '7EbZvRYBb91kW83bWzB509hRf9mmPOi39EIjPpKN'
        },
        body: JSON.stringify(payload)
      })
        .then(response => response.json())
        .then(data => {
          console.log('Data from first API:', data);
          // Make a request to the second API with the data received from the first API
          const payload = {
            source: 'ainxt',
            data: data.body
          };

          fetch('https://s89a50mfw8.execute-api.ap-south-1.amazonaws.com/v1/esign/download', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': 'XSk58ZeGSC7qn7r3V866y2tzKtm4aXtb398beO4X'
            },
            body: JSON.stringify(payload)
          })
            .then(response => response.json())
            .then(responseJson => {
              console.log("This is ", responseJson.data)
              const parsedData = JSON.parse(responseJson.data);
              console.log(parsedData.doc_signed_url);
              setPdfUrl(parsedData.doc_signed_url)
              const pseudonym = parsedData.aadhaar_no
              var decodedString = atob(pseudonym);
              console.log(decodedString, "THIS US BASE64")
              setPseudonym(atob(pseudonym))
              const named = parsedData.name;
              console.log(named)
              var decodeName = atob(named)
              console.log(decodeName, "THIS IS DECODED NAME")

              setName(decodeName)
              const postalcode = parsedData.postal_code
              console.log(postalcode, "this is postal")
              var decodPostal = atob(postalcode)
              setPostal(decodPostal)
              console.log(decodPostal, "THIS IS DECODE POSTAL")
              const urlData = parsedData.doc_signed_url
              console.log(urlData, "This is url")
              window.open(urlData, '_blank');

              const responseBody = JSON.parse(responseJson.body);
              console.log(responseBody, "THISIS IS setPdfUrl")
              const base64Data = responseBody.doc_signed_url;
              console.log(base64Data, "This is Base64 data")


              console.log(pseudonym, "This is adhr no")

              setPdfUrl(`data:application/pdf;base64,${base64Data}`);
              return responseJson
            })
            .catch(error => console.error(error));
        })

        .catch(error =>
          console.error(error));
    }
  }, []);

  const handleDownloadClick = () => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = 'document.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  const openLink = () => {

    window.open(pdfUrl)
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <div className='esignedHeader'>
        Esign Service by AiNXT
      </div>
      <div style={{ display: "flex", flexGrow: 1 }} className="containerBox">
        <div style={{ flex: 1, padding: "20px" }}>
          <div>
            Name: <strong>{Esignname}</strong>
          </div>
          <div>
            Postal: <strong>{postal}</strong>
          </div>
          <div>
            Adhaar ID: <strong>{pseudonym}</strong>
          </div>
          <button className="btn btn-primary mob-w-100 " onClick={openLink}> Open PDF Link</button>
          <span />
          <button onClick={handleDownloadClick} className="btn btn-primary mob-w-100 ">Download Pdf File</button>
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
          {pdfUrl ? (
            <>
              <div style={{ width: '100%', height: '100%', border: 'none', display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <object data={pdfUrl} type="application/pdf" style={{ width: '100%', height: '100%' }}>
                </object>
              </div>
            </>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <ReactBootStrap.Spinner animation="border" />
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          textAlign: "center",
          width: "100%",
          backgroundColor: "#666",
          padding: "10px",
          color: "white",
        }}
      >
        Powered by AiNXT 2023
      </div>
    </div>
  );

}

export default EsigneDownload;
